import React from 'react';
import styles from './ContextMenu.module.scss';
import { Image } from '@yleisradio/areena-types';
import ThumbsUpIcon from '../common/assets/thumbs-up.svg';
import ThumbsDownIcon from '../common/assets/thumbs-down.svg';
import PlayIcon from '../common/assets/play.svg';
import CancelIcon from '../common/assets/close.svg';
import Checked from '../common/assets/checked.svg';

type ContextMenuButtonProps = {
  icon?: Image | undefined;
  onClick: (e: React.MouseEvent | React.KeyboardEvent) => void;
} & React.ButtonHTMLAttributes<HTMLButtonElement>;

const getIcon = (icon: Image | undefined) => {
  if (!icon) return undefined;
  switch (icon.id) {
    case 'play':
      return PlayIcon;
    case 'cancel':
      return CancelIcon;
    case 'icon-check':
      return Checked;
    case 'thumbs-up':
      return ThumbsUpIcon;
    case 'thumbs-down':
      return ThumbsDownIcon;
    default:
      return undefined;
  }
};

const ContextMenuButton: React.FC<ContextMenuButtonProps> = ({
  children,
  onClick,
  icon,
  ...buttonProps
}) => {
  const Icon = getIcon(icon);
  return (
    <button
      className={styles.contextMenu__button}
      onClick={onClick}
      tabIndex={1}
      {...buttonProps}
    >
      {Icon && (
        <span className={styles.icon}>
          <Icon />
        </span>
      )}
      {children}
    </button>
  );
};

export default ContextMenuButton;
